import React, { useState } from 'react';

const JiraTicketModal = ({ isOpen, onClose }) => {
  const [title, setTitle] = useState('');
  const [summary, setSummary] = useState('');
  const [assignee, setAssignee] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle the submission logic here
    console.log({ title, summary, assignee });
    onClose(); // Close the modal after submission
  };

  if (!isOpen) return null;

  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.modal}>
        <h2 style={{ marginBottom: '20px', display: 'inline-block' }}>Create Jira Ticket</h2>
        <span style={{ 
          marginLeft: '10px', 
          backgroundColor: '#FFA500',
          padding: '5px', 
          border: '2px solid black',
          borderRadius: '3px'
        }}>In progress</span>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '15px', marginRight: '20px' }}>
            <label style={{ display: 'block', marginBottom: '5px' }}>Title:</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '3px'
              }}
              required
            />
          </div>
          <div style={{ marginBottom: '15px', marginRight: '20px' }}>
            <label style={{ display: 'block', marginBottom: '5px' }}>Summary:</label>
            <textarea
              value={summary}
              onChange={(e) => setSummary(e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '3px',
                minHeight: '100px'
              }}
              required
            />
          </div>
          <div style={{ marginBottom: '15px', marginRight: '20px' }}>
            <label style={{ display: 'block', marginBottom: '5px' }}>Assignee:</label>
            <input
              type="text"
              value={assignee}
              onChange={(e) => setAssignee(e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '3px'
              }}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <button
              type="button"
              onClick={onClose}
              className="cancel-button"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled
              className="submit-button"
              style={{
                opacity: 0.6
              }}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modal: {
    background: '#fff',
    padding: '40px', // Increased padding for height
    borderRadius: '5px',
    height: '400px', // Doubled width
    width: '500px', // Doubled width
  },
};

export default JiraTicketModal; 